import { render } from "./layoutFooter.vue?vue&type=template&id=ba3bce00&scoped=true"
import script from "./layoutFooter.vue?vue&type=script&lang=js"
export * from "./layoutFooter.vue?vue&type=script&lang=js"

import "./layoutFooter.vue?vue&type=style&index=0&id=ba3bce00&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba3bce00"]])

export default __exports__